// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2u8zb","title":"FrontImage_title__1_QDx"};